/**
 * FE#157 — reconciled server pagination offset for the lazy-loading list.
 *
 * The list previously computed the next `$skip` from `fliterdList.length` — the
 * length of the CLIENT-SIDE `selectByQuery` over the shared Redux store. That
 * count drifts from the server's real offset (realtime inserts, cross-query
 * store pollution, dedup, sort-tie ordering). When the client count runs ahead
 * of the true offset, `$skip` over-skips and the server never returns the rows
 * in between — they vanish between pages.
 *
 * Fix: advance a dedicated offset by the number of rows the SERVER actually
 * returned for each page (from the find thunk's unwrapped result), independent
 * of whatever the client store currently holds. `$skip` then exactly equals the
 * cumulative server rows: no skipped rows, no duplicates.
 */
export function advanceServerOffset(currentOffset: number, serverPageCount: number): number {
  const base = Number.isFinite(currentOffset) && currentOffset > 0 ? Math.floor(currentOffset) : 0;
  const add = Number.isFinite(serverPageCount) && serverPageCount > 0 ? Math.floor(serverPageCount) : 0;
  return base + add;
}
